import type { NDateLocale } from './enUS'
import { bg } from 'date-fns/locale'

const dateBgBG: NDateLocale = {
  name: 'bg-BG',
  locale: bg
}

export default dateBgBG
